module.exports = global["window"]["jQuery"] = require("-!/home/circleci/repo/bower_components/jquery/dist/jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?window.jQuery!./bower_components/jquery/dist/jquery.js
// module id = 3
// module chunks = 0 1